<template>
  <!-- sm md lg xl xxl -->
  <div class="index-page">
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="left col-6 fs-2"><img src="../assets/images/logo.png" /></div>
          <div class="right col-6">
            <!-- <div class="btn btn-proxy">全包代理</div> -->
            <div class="btn btn-proxy" v-if="isToken" @click="handlePay">
              充值额度(剩<span>{{ userInfo.create_rz_num }}次</span>)
            </div>
            <template v-if="!isToken">
              <div class="btn btn-base" @click="handleLogin">
                登录
              </div>
            </template>
            <template v-else>
              <a-dropdown>
                <div class="btn btn-user" style="display: flex;align-items: center;">
                  <a-avatar :size="26" :src="userInfo.head_image" v-if="userInfo.head_image" />
                  <span style="margin: 0 4px;">{{ userInfo.account }}</span>
                  <a-icon type="down" />
                </div>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <div @click="handleLogout">退出登录</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="banner pt-5 pb-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 pt-5 pb-5 pe-5">
            <div class="left ">
              <div class="fs-0 lh-base"><strong>1个名称</strong></div>
              <div class="fs-0 lh-base"><strong>10分钟完成软著材料</strong></div>
              <div class="mt-4 mb-4 fs-5 lh-base">AI驱动的专业软著材料生成系统，拒绝模板化，100%原创代码和文档，确保高通过率</div>
              <div class="tags">
                <div class="tag">
                  <img src="../assets/images/banner-tag-01.png" />
                  60页专属代码
                </div>
                <div class="tag">
                  <img src="../assets/images/banner-tag-02.png" />
                  材料图文并茂
                </div>
                <div class="tag">
                  <img src="../assets/images/banner-tag-03.png" />
                  真实可运行程序
                </div>
              </div>
              <div class="count">
                <div class="row">
                  <div class="item col-4">
                    <div class="num fs-0"><strong>1000+</strong></div>
                    <div class="fs-6">成功案例</div>
                  </div>
                  <div class="item col-4">
                    <div class="num fs-0"><strong>98.6%</strong></div>
                    <div class="fs-6">一次通过率</div>
                  </div>
                  <div class="item col-4">
                    <div class="num fs-0"><strong>10min</strong></div>
                    <div class="fs-6">生成时间</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="right">
              <div class="write">
                <div class="line"></div>
                <div class="main">
                  <div class="title">
                    <div class="tit">
                      <img src="../assets/images/banner-title.png" />
                      创建软著项目
                    </div>
                    <div class="desc"></div>
                  </div>
                  <div class="step">
                    <div class="item item-first">
                      <div class="piont"></div>
                      <div class="text">填写信息</div>
                    </div>
                    <div class="line"></div>
                    <div class="item">
                      <div class="piont"></div>
                      <div class="text">生成材料</div>
                    </div>
                    <div class="line"></div>
                    <div class="item">
                      <div class="piont"></div>
                      <div class="text">下载文档</div>
                    </div>
                    <div class="line"></div>
                    <div class="item">
                      <div class="piont"></div>
                      <div class="text">前往申报</div>
                    </div>
                  </div>
                  <div class="form">
                    <a-form-model ref="ruleForm" :rules="rules" :model="ruleForm" :colon="false" :label-col="labelCol"
                      :wrapper-col="wrapperCol">
                      <a-form-model-item label="平台名称" prop="name">
                        <a-auto-complete v-model="ruleForm.name" :data-source="dataSource"
                          placeholder="请输入项目名称，建议使用“软件”“平台”或“APP”结尾" @search="handleSearch" />
                      </a-form-model-item>
                      <a-form-model-item label="设备类型" prop="type">
                        <a-radio-group v-model="ruleForm.type">
                          <a-radio :value="1">PC,Web,平板</a-radio>
                          <a-radio :value="3">小程序</a-radio>
                          <a-radio :value="4">安卓</a-radio>
                          <a-radio :value="5">IOS</a-radio>
                        </a-radio-group>
                      </a-form-model-item>
                      <!-- <a-form-model-item label="域名前缀" prop="prefix">
                        <a-input v-model="ruleForm.prefix" placeholder="请输入域名前缀，用于显示在界面图上" />
                      </a-form-model-item> -->
                      <a-form-model-item label="权利人" prop="person">
                        <a-input v-model="ruleForm.person" placeholder="请输入权利人名称" />
                      </a-form-model-item>
                      <a-form-model-item label="版本号" prop="version">
                        <a-input v-model="ruleForm.version" placeholder="请输入版本号" />
                      </a-form-model-item>
                      <a-form-model-item label="项目简介" prop="content">
                        <a-input v-model="ruleForm.content" :rows="4" :autoSize="false" type="textarea" :maxLength="500"
                          placeholder="请输入项目简介(20-500字)，如:项目的核心功能、技术特点、面向用户、面向平台等" />
                      </a-form-model-item>
                    </a-form-model>
                    <div class="btn" @click="handleSubmit">
                      <img src="../assets/images/banner-btn.png" />
                      开始生成材料
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main mb-3" v-if="listData && listData.length > 0">
      <div class="title mt-4 mb-4 fs-4 text-dark">
        <div class="container">
          <div class="row">
            <div class="left col-6"><strong>最近项目</strong></div>
            <div class="right col-6">
              <!-- <div class="btn btn-outline-base">查看全部项目</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="list container">
        <div class="row">
          <div class="mb-3" v-for="(item, index) in listData" :key="index">
            <list-card :key="item.id" :itemData="item" @delete="handleDelete"></list-card>
          </div>
        </div>
        <div class="no-more" v-if="isMore">
          <div class="btn btn-outline-base" @click="handleMore">加载更多</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="row gx-4">
          <div class="left col-sm-12 col-lg-5 mt-3 mb-3">
            <div class="text-primary-color fs-5">软著123</div>
            <div class="text-primary-color fs-6">www.ruanzhu123.com</div>
            <div class="text-base-color-3 fs-8">AI软著申报助手，您的信赖之选。</div>
            <div class="text-base-color-3 fs-8">专业AI赋能，让软著申报更简单、更高效。</div>
            <div class="text-base-color-2 fs-8" style="margin-top: 4px;">
              © 2025 安徽英弗伦斯科技有限公司 皖ICP备13011855号-4
            </div>
          </div>
          <div class="mid col-sm-12 col-lg-5 mt-3 mb-3">
            <div class="text-primary-color fs-5" style="margin-bottom: 10px;">
              联系我们
            </div>
            <div class="text-base-color-3 fs-7" style="display: flex;align-items: center;">
              <a-icon type="mail" theme="filled" style="font-size: 12px;color: #C5C5C5;" />
              <span style="margin-left: 10px;">542873955@qq.com</span>
            </div>
            <div class="text-base-color-3 fs-7" style="display: flex;align-items: center;">
              <a-icon type="phone" theme="filled" style="font-size: 12px;color: #C5C5C5;" />
              <span style="margin-left: 10px;">13365651124</span>
            </div>
            <div class="text-base-color-3 fs-7" style="display: flex;align-items: center;">
              <a-icon type="clock-circle" theme="filled" style="font-size: 12px;color: #C5C5C5;" />
              <span style="margin-left: 10px;">工作日 9:00-18:00</span>
            </div>
          </div>
          <div class="right col-sm-12 col-lg-2 mt-3 mb-3">
            <img src="../assets/images/ewm.png" style="width: 120px;height: 120px;" />
          </div>
        </div>
      </div>
    </div>
    <login-dialog ref="loginDialogRef" @list="getList"></login-dialog>
    <pay-dialog ref="payDialogRef" @completed="handleCompleted"></pay-dialog>
  </div>
</template>

<script>
import ListCard from '@/components/ListCard.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import PayDialog from '@/components/PayDialog.vue';
import { getOrderListApi, createtOrderApi, deleteOrderApi, createTitleApi } from '@/api/soft.js';

export default {
  name: 'IndexPage',
  components: {
    ListCard,
    LoginDialog,
    PayDialog
  },
  computed: {
    isToken() {
      return this.$store.state.token
    },
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      // ruleForm: {
      //   name: '软著123',
      //   type: 1,
      //   prefix: 'domin',
      //   person: '安徽英弗伦斯',
      //   version: 'v1.0',
      //   content: 'AI驱动的专业软著材料生成系统，拒绝模板化，100%还原创代码和文档，确保高通过率',
      // },
      ruleForm: {
        name: '',
        type: 1,
        prefix: '',
        person: '',
        version: 'V1.0',
        content: '',
      },
      rules: {
        name: [{ required: true, message: '必填项', trigger: 'blur' }],
        type: [{ required: true, message: '必填项', trigger: 'blur' }],
        // prefix: [{ required: true, message: '必填项', trigger: 'blur' }],
        person: [{ required: true, message: '必填项', trigger: 'blur' }],
        version: [{ required: true, message: '必填项', trigger: 'blur' }],
        // content: [{ required: true, message: '必填项', trigger: 'blur' }],
      },
      dataSource: [],
      page: 1,
      size: 5,
      isMore: true,
      listData: [],
      isPay: false, // 是否有支付未完成
    }
  },
  methods: {
    // 平台名称 选项
    async handleSearch(searchText) {
      const str = searchText.trim()
      if (str.length >= 4) {
        const res = await createTitleApi({
          title: searchText
        })
        if (res.code == 0) {
          this.dataSource = res.data.result
        }
      }
    },
    // 获取 用户信息
    getInfo() {
      this.$store
        .dispatch('GetInfo')
        .then(() => {
          // console.log('获取用户信息成功')
        })
        .catch(() => {
          // console.error('获取用户信息失败')
        })
    },
    // 订单 列表
    async getList() {
      if (!this.isToken) return
      const res = await getOrderListApi(this.page, this.size)
      if (res.code == 0) {
        this.listData = this.listData.concat(res.data.items)
        this.isMore = res.data.totalCount > this.listData.length
      }
    },
    refreshData() {
      this.listData = []
      this.page = 1
      this.size = 5
      this.getList()
    },
    // 加载 更多
    handleMore() {
      this.page++
      this.getList()
    },
    // 订单 删除
    async handleDelete(id) {
      const res = await deleteOrderApi({
        id
      })
      if (res.code == 0) {
        const index = this.listData.findIndex(item => item.id === id)
        this.listData.splice(index, 1)
        this.$message.success('删除成功')
        // this.refreshData()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 充值
    handlePay() {
      this.$refs['payDialogRef'].handleOpen()
    },
    // 充值 完成
    handleCompleted() {
      setTimeout(() => {
        if (this.isPay) {
          const createNum = this.$store.state.userInfo.create_rz_num
          if (createNum > 0) {
            this.handleSubmit()
          }
        }
      }, 500)
    },
    // 登录
    handleLogin() {
      this.$refs['loginDialogRef'].handleOpen()
    },
    // 登出
    handleLogout() {
      this.$store
        .dispatch('Logout')
        .then(() => {
          window.location.reload()
        })
    },
    // 软著 生成
    handleSubmit() {
      if (!this.isToken) return this.$message.error('请先登录')
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const res = await createtOrderApi({
            project_name: this.ruleForm.name,
            device_type: this.ruleForm.type,
            domain_name: this.ruleForm.prefix,
            company: this.ruleForm.person,
            version: this.ruleForm.version,
            project_desc: this.ruleForm.content,
          })
          if (res.code == 0) {
            this.$message.success('提交成功')
            this.refreshData()
            this.getInfo()
            this.isPay = false
          } else {
            this.$message.error(res.msg)
            if (res.code == 6666) {
              this.handlePay()
              this.isPay = true
            }
          }
        } else {
          return false
        }
      });
    },
  },
  created() {
    const token = window.localStorage.getItem('token')
    if (token) {
      this.getList()
    }
  },
}
</script>

<style lang="scss" scoped>
.index-page {
  color: #fff;

  .header {
    position: sticky;
    top: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    height: 60px;
    background-color: #6F7AFF;

    .left {
      display: flex;
      align-items: center;

      img {
        width: auto;
        height: 1em;
      }
    }

    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  .banner {
    background-image: url('../assets/images/banner-bg.png');
    background-color: #6F7AFF;
    background-position: bottom left;
    background-repeat: no-repeat;
    background-size: cover;

    .left {
      .tags {
        display: flex;
        align-items: center;
        margin-bottom: 100px;

        .tag {
          display: flex;
          align-items: center;
          margin-right: 10px;
          padding: 6px 12px;
          font-size: 14px;
          color: #333333;
          background: #FFFFFF;
          border-radius: 20px;

          img {
            margin-right: 4px;
            width: 14px;
            height: auto;
          }
        }
      }

      .count {
        .item {
          text-align: center;

          .num {
            color: #FFFA69;
          }
        }
      }
    }

    .right {
      .write {
        background-image: url('../assets/images/card-bg.png');
        background-color: #fff;
        background-position: top left;
        background-repeat: no-repeat;
        background-size: contain;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

        &>.line {
          width: 100%;
          height: 4px;
          background: linear-gradient(90deg, #7845ff, #ff4372);
        }

        .main {
          padding: 10px 20px;

          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 30px;

            .tit {
              display: flex;
              align-items: center;
              font-size: 18px;
              font-weight: bolder;
              color: #333333;

              img {
                margin-right: 6px;
                width: 24px;
                height: 24px;
              }
            }

            .desc {
              font-size: 14px;
              color: #333333;
              line-height: 20px;
            }
          }

          .step {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            padding: 10px 16px;
            background: #FAF5FF;
            border-radius: 8px;
            border: 1px solid #EBDEF5;

            .item {
              display: flex;
              align-items: center;

              .piont {
                margin-right: 6px;
                width: 8px;
                height: 8px;
                background-color: #CEBDDF;
                border-radius: 50%;
              }

              .text {
                font-size: 14px;
                color: #333;
              }
            }

            .item-first {
              .piont {
                background-color: #7557D9;
                box-shadow: 0 0 4px 1px rgba(117, 87, 217, 1);
              }

              .text {
                color: #7557D9;
              }
            }

            .line {
              width: 34px;
              height: 1px;
              background-color: #CEBDDF;
            }
          }

          .form {
            .ant-form-item {
              margin-bottom: 20px;

              :deep .ant-form-explain {
                display: none;
              }
            }

            .ant-form-item-with-help {
              margin-bottom: 20px;
            }

            .btn {
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0;
              width: 100%;
              height: 42px;
              background-color: #5B66FF;
              font-size: 16px;
              line-height: 1;
              color: #fff;
              border-radius: 6px;

              img {
                margin-right: 10px;
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }

  .main {
    .title {
      .left {
        // color: #333333;
      }

      .right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }

    .list {
      .no-more {
        display: flex;
        justify-content: center;
      }
    }
  }

  .footer {
    padding: 20px 0;
    background-color: #F3F4FF;
  }
}
</style>
